import React, { useEffect } from "react";
import MainLayout from "../../Layout/mainLayout";
import "./viewFAQ.css";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getFAQById } from "../../Redux/Actions/faqsAction";

const ViewFAQ = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { singleFaq, loading, error } = useSelector((state) => state.faq || {});
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canEdit = Array.isArray(accessCode) && accessCode.includes("edit");

  useEffect(() => {
    if (id) dispatch(getFAQById(id));
  }, [dispatch, id]);

  const data = singleFaq;

  if (loading)
    return (
      <MainLayout>
        <div className="vf-state-wrapper">
          <div className="vf-spinner" />
          <p className="vf-state-text">Loading FAQ...</p>
        </div>
      </MainLayout>
    );

  if (error)
    return (
      <MainLayout>
        <div className="vf-state-wrapper">
          <div className="vf-state-icon vf-state-icon--error">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
          </div>
          <p className="vf-state-text">Error: {error}</p>
        </div>
      </MainLayout>
    );

  if (!data)
    return (
      <MainLayout>
        <div className="vf-state-wrapper">
          <div className="vf-state-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
          </div>
          <p className="vf-state-text">No FAQ data available</p>
        </div>
      </MainLayout>
    );

  const isGeneralQueries = (() => {
    const val = String(data.page || "").toLowerCase();
    return (
      val === "general_queries" ||
      val === "general queries" ||
      val === "generalquery" ||
      val === "generalqueries"
    );
  })();

  const formatDate = (dateStr) =>
    dateStr
      ? new Date(dateStr).toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })
      : "—";

  return (
    <MainLayout>
      <div className="vf-wrapper">

        {/* ── Header ── */}
        <div className="vf-header">
          <div className="vf-header-left">
            <div className="vf-header-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                <line x1="12" y1="17" x2="12.01" y2="17" />
              </svg>
            </div>
            <div>
              <h1 className="vf-title">FAQ Details</h1>
              <p className="vf-subtitle">Viewing full information for this FAQ</p>
            </div>
          </div>
          <button className="vf-back-btn" type="button" onClick={() => navigate("/faq")}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M19 12H5M12 19l-7-7 7-7" />
            </svg>
            Back to List
          </button>
        </div>

        {/* ── Body ── */}
        <div className="vf-body">

          {/* ── Left: Quick Info ── */}
          <div className="vf-left">
            <div className="vf-quick-card">

              <div className="vf-quick-icon-wrap">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                  <circle cx="12" cy="12" r="10" />
                  <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                  <line x1="12" y1="17" x2="12.01" y2="17" />
                </svg>
              </div>

              <div className="vf-quick-row">
                <span className="vf-quick-label">Page</span>
                <span className="vf-quick-value">{data.page || "—"}</span>
              </div>
              <div className="vf-divider" />

              <div className="vf-quick-row">
                <span className="vf-quick-label">Status</span>
                <span className={`vf-badge vf-badge--${(data.status || "").toLowerCase()}`}>
                  {data.status || "—"}
                </span>
              </div>
              <div className="vf-divider" />

              <div className="vf-quick-row">
                <span className="vf-quick-label">Answer Required</span>
                <span className={`vf-badge ${isGeneralQueries ? "vf-badge--no" : "vf-badge--yes"}`}>
                  {isGeneralQueries ? "No" : "Yes"}
                </span>
              </div>
              <div className="vf-divider" />

              <div className="vf-quick-row">
                <span className="vf-quick-label">Created</span>
                <span className="vf-quick-value">{formatDate(data.created_at)}</span>
              </div>
              <div className="vf-divider" />

              <div className="vf-quick-row">
                <span className="vf-quick-label">Updated</span>
                <span className="vf-quick-value">{formatDate(data.updated_at)}</span>
              </div>

            </div>
          </div>

          {/* ── Right: Detail Cards ── */}
          <div className="vf-right">

            {/* Card 1: Question */}
            <div className="vf-card">
              <div className="vf-card-header">
                <span className="vf-card-badge">01</span>
                <h2 className="vf-card-title">Question</h2>
              </div>
              <div className="vf-content-block">
                <svg className="vf-content-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10" />
                  <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                  <line x1="12" y1="17" x2="12.01" y2="17" />
                </svg>
                <p className="vf-content-text">{data.question || "—"}</p>
              </div>
            </div>

            {/* Card 2: Answer */}
            {!isGeneralQueries && (
              <div className="vf-card">
                <div className="vf-card-header">
                  <span className="vf-card-badge">02</span>
                  <h2 className="vf-card-title">Answer</h2>
                </div>
                <div className="vf-content-block">
                  <svg className="vf-content-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                  </svg>
                  <p className="vf-content-text">{data.answer || "—"}</p>
                </div>
              </div>
            )}

            {/* General Query Note */}
            {isGeneralQueries && (
              <div className="vf-card">
                <div className="vf-card-header">
                  <span className="vf-card-badge">02</span>
                  <h2 className="vf-card-title">Answer</h2>
                </div>
                <div className="vf-info-box">
                  <span className="vf-info-badge">General Query</span>
                  <p className="vf-info-text">
                    This FAQ belongs to General Queries — no answer is required for this page type.
                  </p>
                </div>
              </div>
            )}

            {/* Card 3: Meta Info */}
            <div className="vf-card">
              <div className="vf-card-header">
                <span className="vf-card-badge">03</span>
                <h2 className="vf-card-title">Record Information</h2>
              </div>
              <div className="vf-grid vf-grid-2">
                <div className="vf-info-item">
                  <span className="vf-info-label">FAQ ID</span>
                  <span className="vf-info-value vf-mono">{data._id || "—"}</span>
                </div>
                <div className="vf-info-item">
                  <span className="vf-info-label">Page</span>
                  <span className="vf-info-value">{data.page || "—"}</span>
                </div>
                <div className="vf-info-item">
                  <span className="vf-info-label">Created At</span>
                  <span className="vf-info-value">{formatDate(data.created_at)}</span>
                </div>
                <div className="vf-info-item">
                  <span className="vf-info-label">Updated At</span>
                  <span className="vf-info-value">{formatDate(data.updated_at)}</span>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* ── Footer Actions ── */}
        {canEdit && (
          <div className="vf-footer">
            <button type="button" className="vf-btn vf-btn--cancel" onClick={() => navigate("/faq")}>
              Cancel
            </button>
            <button type="button" className="vf-btn vf-btn--edit" onClick={() => navigate(`/faq/edit/${id}`)}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
              </svg>
              Edit FAQ
            </button>
          </div>
        )}

      </div>
    </MainLayout>
  );
};

export default ViewFAQ;